import { render } from "./Tab.vue?vue&type=template&id=5e75a8b1&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=5e75a8b1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e75a8b1"

export default script